<template>
  <div class="mod-rm__selectCourse">
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form :inline="true"
               :model="dataForm"
               @keyup.enter.native="getDataList()"
               label-position="left"
               label-width="100px">
        <el-row>
          <!-- 第一行 -->
          <el-col :span="7">
            <!-- 课程编号 -->
            <el-form-item :label="$t('res.courseclassroomrela.courseNo')">
              <el-input v-model="dataForm.courseNo"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 课程名称 -->
            <el-form-item :label="$t('res.courseclassroomrela.courseName')">
              <el-input v-model="dataForm.coursecName"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 课程分类 -->
            <el-form-item prop="classcName"
                          :label="$t('res.courseclassroomrela.courseClassId')">
              <class-tree ref="courseRef"
                          v-on:getSelectList="getCourseList"
                          v-bind:defaultProps="CourseProps"
                          v-bind:url="queryCourseUrl"
                          v-bind:isSelect=false
                          v-bind:status="'courseStatus'"></class-tree>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item>
              <el-button type="primary" class="M-search" @click="queryCourse()">{{ $t('query') }}</el-button>
            </el-form-item>
          </el-col>

          <!-- 第二行 -->
          <el-col :span="7">
            <!-- 团队分类 -->
            <el-form-item prop="teamClassList"
                          :label="$t('res.courseclassroomrela.teamClassification')">
              <class-tree ref="classRef"
                          v-on:getSelectList="getSelectList"
                          v-bind:defaultProps="defaultProps"
                          v-bind:url="queryTreeUrl"
                          v-bind:isSelect=false></class-tree>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item>

            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item>

            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item>
              <el-button type="info" class="el-back M-search M-margin-l" @click="resetQueryData()">{{ $t('reset') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-form-item>
              <!-- 确定按钮 -->
              <el-button type="primary"
                         class="M-search"
                         @click="couronOk">{{ $t('res.courseclassroomrela.determine') }}</el-button>
            </el-form-item>
            <el-col :span="21">&nbsp;</el-col>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="dataList"
                @select="selectRedio"
                border
                class="select_style"
                v-loading="dataListLoading"
                ref="coursePlanTable"
                style="width: 100%;">
        <el-table-column header-align="center"
                         type="selection"
                         align="center"
                         width="50">
        </el-table-column>
        <!-- 序号 -->
        <el-table-column prop="courseId"
                         header-align="center"
                         align="center"
                         v-if="false"
                         :label="ID">
        </el-table-column>
        <!-- 课程编号 -->
        <el-table-column prop="courseNo"
                         header-align="center"
                         align="center"
                         :label="$t('res.courseclassroomrela.courseNo')">
        </el-table-column>
        <!-- 课程名称 -->
        <el-table-column prop="coursecName"
                         header-align="center"
                         align="center"
                         :label="$t('res.courseclassroomrela.courseName')">
        </el-table-column>
        <!-- 课程分类1 -->
        <el-table-column prop="classcName1"
                         header-align="center"
                         align="center"
                         :label="$t('res.courseclassroomrela.courseClassId1')">
        </el-table-column>
        <!-- 课程分类2 -->
        <el-table-column prop="classcName2"
                         header-align="center"
                         align="center"
                         :label="$t('res.courseclassroomrela.courseClassId2')">
        </el-table-column>
        <!-- 课程分类3 -->
        <el-table-column prop="classcName3"
                         header-align="center"
                         align="center"
                         :label="$t('res.courseclassroomrela.courseClassId3')">
        </el-table-column>
        <!-- 团队分类 -->
        <el-table-column prop="teamName"
                         header-align="center"
                         align="center"
                         :label="$t('res.courseclassroomrela.teamClassification')">
        </el-table-column>
        <!-- 最大人数 -->
        <el-table-column prop="maxPersonNo"
                         header-align="center"
                         align="center"
                         width="150"
                         :label="$t('res.courseclassroomrela.maxPersonNo')">
        </el-table-column>
        <!-- 最小人数 -->
        <el-table-column prop="miniPersonNo"
                         header-align="center"
                         align="center"
                         width="100"
                         :label="$t('res.courseclassroomrela.miniPersonNo')">
        </el-table-column>
        <!-- 课程状态 -->
        <el-table-column prop="status"
                         header-align="center"
                         align="center"
                         width="100"
                         :label="$t('res.courseclassroomrela.coursesSatus')">
        </el-table-column>
        <!-- 课程时间 -->
        <el-table-column prop="courseTime"
                         header-align="center"
                         align="center"
                         width="100"
                         :label="$t('res.courseclassroomrela.courseTime')">
        </el-table-column>
        <!-- 课程分类 -->
        <el-table-column prop="classcNameMerge"
                         header-align="center"
                         align="center"
                         width="100"
                         v-if="false"
                         :label="$t('res.courseclassroomrela.courseClassId')">
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import ClassTree from '@/components/rm/class-tree/index'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/rm/coursevehiclerela/courselist',
        getDataListIsPage: true,
        deleteURL: '/rm/coursevehiclerela/delete',
        deleteIsBatch: true,
        exportURL: '/rm/coursevehiclerela/export'
      },
      dataForm: {
        courseNo: '',
        coursecName: '',
        classcName: '',
        teamName: '',
        teamClassList: []
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      // 团队分类
      defaultProps: {
        children: 'children',
        label: 'treamCnName'
      },
      queryTreeUrl: '/rm/courseclassroomrela/treamClassTreeRela',
      // 课程分类树
      CourseProps: {
        children: 'children',
        label: 'classCname'
      },
      queryCourseUrl: '/rm/courseclassroomrela/courseClassTreeRela'
    }
  },
  props: {
    url: {// 文件提交位置
      type: String,
      required: true
    }
  },
  components: {
    'class-tree': ClassTree
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.dataForm = {
        courseNo: '',
        coursecName: '',
        classcName: '',
        teamName: '',
        teamClassList: []
      }
      this.$refs.classRef.resetChecked()
      this.$refs.courseRef.resetChecked()
      this.getDataList()
    },
    gotoView (type, id) {
      let query = {}
      let name = 'rm-coursevehiclerela-add-or-update'
      query.courseVehicleRelaId = id
      if (type === 'view') {
        name = 'rm-coursevehiclerela-view'
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'update') {
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'delete') {
        this.deleteHandle(id)
      }
    },
    couronOk () {
      let select = this.$refs.coursePlanTable.selection
      if (select.length <= 0) {
        this.$message.warning(this.$t('res.courseclassroomrela.courseSelectCheck'))
        return false
      }
      console.info(select[0].courseId)
      let _this = this
      _this.$request.get(this.url + `/${select[0].courseId}`).then((res, msg, code, data) => {
        if (data.data > 0) {
          _this.$message({
            message: _this.$t('res.courseclassroomrela.repeatQuery'),
            type: 'failed'
          })
          return false
        }
        _this.$emit('couronOk', select[0])
        _this.$refs.coursePlanTable.clearSelection()
      })
    },
    Update (row) {
      let query = {}
      query.courseId = row.courseId
      console.info('cccccccccccc')
      console.info(row)
      console.info(query.courseId)
      console.info('dddddddddddd')
      console.info(query.courseId, row)
      this.$router.push({
        name: name,
        query: query
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 单选
    selectRedio: function selectRedio (selection, row) {
      if (this.$refs.coursePlanTable.selection.length > 1) {
        this.$refs.coursePlanTable.clearSelection()
        this.$refs.coursePlanTable.toggleRowSelection(row)
      }
    },
    getSelectList (args) {
      let teamClass = []
      args.forEach(function (item) {
        teamClass.push(item.id)
      })
      this.dataForm.teamClassList = teamClass
    },
    // 重置查询条件
    resetQueryData () {
      this.dataForm = {}
      this.$refs.classRef.resetChecked()
      this.$refs.courseRef.resetChecked()
      this.queryCourse()
    },
    queryCourse () {
      this.page = 1
      this.getDataList()
    },
    getCourseList (args) {
      if (args && args !== '' && args.length > 0) {
        let courseArr = []
        args.forEach(function (item) {
          courseArr.push(item.id)
        })
        // to string
        this.dataForm.classcName = courseArr.join(',')
      } else {
        this.dataForm.classcName = ''
      }
    }
  }
}
</script>
<style>
.mod-rm__selectCourse thead .el-table-column--selection .cell {
  display: none !important;
}
</style>
